import ClassenService from '../ClassenService';

class RangeService {
  getRanges() {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/ranges`);
  }

  addRange(rangeData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/ranges`, 'addRange', rangeData);
  }

  getRange(rangeId) {
    return ClassenService.doApiCall('get', `${process.env.VUE_APP_API}/ranges/${rangeId}`);
  }

  updateRange(rangeId, rangeData) {
    return ClassenService.doApiCall('put', `${process.env.VUE_APP_API}/ranges/${rangeId}`, 'updateRange', rangeData);
  }

  deleteRange(rangeId) {
    return ClassenService.doApiCall('delete', `${process.env.VUE_APP_API}/ranges/${rangeId}`, 'deleteRange');
  }

  searchRanges(searchData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/ranges/search`, 'searchData', searchData);
  }
}

export default new RangeService();
